// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","container":"_2K4K1","text":"_1cD5v","content":"_1IxJG"};